import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/home/fronteu/ampmworldfrontend/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/ui/header-background/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/src/views/addresses/components/addresses-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/addresses/components/addresses-map/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/addresses/index.module.scss");
